import { render, staticRenderFns } from "./JobDetails.vue?vue&type=template&id=d31f0db6&scoped=true&"
import script from "./JobDetails.vue?vue&type=script&lang=js&"
export * from "./JobDetails.vue?vue&type=script&lang=js&"
import style0 from "./JobDetails.vue?vue&type=style&index=0&id=d31f0db6&scoped=true&lang=css&"
import style1 from "./JobDetails.vue?vue&type=style&index=1&id=d31f0db6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31f0db6",
  null
  
)

export default component.exports